var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56087 0C5.86848 0 3.68587 2.18261 3.68587 4.875C3.68587 7.56739 5.86848 9.75 8.56087 9.75C11.2533 9.75 13.4359 7.56739 13.4359 4.875C13.4359 2.18261 11.2533 0 8.56087 0Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56221 10.8333C4.42613 10.8333 1.3285 13.5259 0.131392 17.2055C-0.476167 19.073 1.12746 20.5833 2.8023 20.5833H12.0817V16.8587C10.93 15.9683 10.1859 14.5721 10.1859 13C10.1859 12.3108 10.3289 11.655 10.5869 11.0606C9.94518 10.9119 9.26885 10.8333 8.56221 10.8333Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0609 9.75C13.2659 9.75 11.8109 11.2051 11.8109 13C11.8109 14.3116 12.5879 15.4418 13.7067 15.9553V19.7813C13.7067 19.9459 13.7815 20.1015 13.91 20.2043L14.7225 20.8543C14.9203 21.0126 15.2014 21.0126 15.3992 20.8543L16.2117 20.2043C16.3402 20.1015 16.415 19.9459 16.415 19.7813V19.12C16.415 18.9667 16.3501 18.8206 16.2363 18.7179L15.6025 18.1458L16.2564 17.492C16.358 17.3904 16.415 17.2526 16.415 17.109V15.9553C17.5339 15.4418 18.3109 14.3116 18.3109 13C18.3109 11.2051 16.8558 9.75 15.0609 9.75ZM13.9775 13C13.9775 12.4017 14.4626 11.9167 15.0609 11.9167C15.6592 11.9167 16.1442 12.4017 16.1442 13C16.1442 13.5983 15.6592 14.0833 15.0609 14.0833C14.4626 14.0833 13.9775 13.5983 13.9775 13Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionPin);
export default __webpack_public_path__ + "static/media/transaction-pin.699895cdab3dae0f131b3d513e095533.svg";
export { ForwardRef as ReactComponent };